import { withRBAC } from "../../../rbac";
import { PayrollComponentCreate } from "./Create";
import { PayrollComponentEdit } from "./Edit";
import { PayrollComponentList } from "./List";

export const payrollComponents = {
  list: withRBAC(PayrollComponentList, "view_hr"),
  create: withRBAC(PayrollComponentCreate, "manage_hr"),
  edit: withRBAC(PayrollComponentEdit, "manage_hr"),
  recordRepresentation: "name",
};
